import { useState } from "react"
import { Check } from "lucide-react"
import { useTranslations } from "modules/i18n/hooks/useTranslations"

/**
 * Success message shown after successful subscription.
 * Includes confirmation and help text with popover for troubleshooting.
 */
export const SuccessMessage = () => {
  const [showPopover, setShowPopover] = useState(false)
  const t = useTranslations("newsletters")

  return (
    <div className="flex min-h-20 flex-col items-center justify-center gap-1 text-center">
      <div className="flex flex-col items-center justify-center gap-2">
        <div className="flex flex-col items-center justify-center gap-4">
          <div className="flex size-10 items-center justify-center rounded-full bg-green-300 text-black">
            <Check className="size-6" strokeWidth={1.5} />
          </div>
          <h3 className="text-xl font-semibold md:text-2xl">{t("v2.success.heading")}</h3>
        </div>
        <p className="mb-4 text-base">
          {t("v2.success.message")}{" "}
          <button
            onClick={() => setShowPopover(!showPopover)}
            className="cursor-pointer text-gray-600 underline hover:text-indigo-500 hover:no-underline"
          >
            {t("v2.success.help_link")}
          </button>
          {showPopover && (
            <span className="mt-2 block text-sm text-gray-600">{t("v2.success.help_text")}</span>
          )}
        </p>
      </div>
    </div>
  )
}
